import cx from 'classnames';
import { capfirst, intcomma } from 'journalize';
import { Component, h, VNode } from 'preact';

import PartyPill from './PartyPill';
import PureComponent from './PureComponent';

import { isCanvass } from '../endpoints';

import formatPercent from '../utils/format-percent';

interface Props {
  ballotName: string;
  candidateId: string;
  contestIsCalled: boolean;
  contestResult: string;
  isIncumbent: boolean;
  isWinner: boolean;
  isMapRow: boolean;
  candidatesNum: number;
  party: string;
  totalVotesInContest: number;
  votes: number;
}

class CandidateRow extends Component<Props> {
  static Header: VNode;
  static countyHeader: VNode;
  static columnCount: number;

  render() {
    const {
      ballotName,
      contestIsCalled,
      contestResult,
      isIncumbent,
      isWinner,
      isViewable,
      candidateColor,
      candidatesNum,
      isMapRow,
      party,
      totalVotesInContest,
      votes,
    } = this.props;

    let divStyle;

    let checkStyle;

    if (candidateColor) {
      divStyle = {
        'background-color': candidateColor,
      };
      checkStyle = {
        color: candidateColor,
      };
    }

    let rowClass = cx('candidate', 'contest__candidate-row', {
      'contest__candidate-row--winner dem--border':
        contestIsCalled && isWinner && party == 'Democrat',
      'contest__candidate-row--winner rep--border':
        contestIsCalled && isWinner && party == 'Republican',
    });

    let checkClass = cx('check', {
      'dem-winner': party == 'Democrat' && contestResult != 'runoff',
      'rep-winner': party == 'Republican' && contestResult != 'runoff',
      'runoff-winner': contestResult == 'runoff',
    });

    if (!isViewable) {
      rowClass += ' race__candidate-row--hidden';
    }

    const checkmark = '\u2713';

    const uncontested = candidatesNum == 1;

    const asteriskNames = [
      'Andrew White',
      'Amanda Edwards',
      'Scott Mandel',
      'Jay Nagy',
    ];

    const IsAsterisk = asteriskNames.includes(ballotName);

    return (
      <tr class={rowClass}>
        <td class="candidate__cell candidate__party">
          {!candidateColor && <PartyPill party={party} />}
          {candidateColor && <PartyPill party={party} style={divStyle} />}
        </td>
        <th class="candidate__cell candidate__name">
          {isWinner &&
            (contestResult == 'winner' || contestResult == 'uncontested') && (
              <span class={checkClass}>{checkmark}</span>
            )}
          {isWinner && contestResult == 'runoff' && (
            <span class={checkClass}>{checkmark}</span>
          )}
          {isWinner &&
          isMapRow == null &&
          isCanvass == true &&
          contestResult != 'runoff' ? (
            <span class={checkClass}>{ballotName}</span>
          ) : (
            ballotName
          )}
          {IsAsterisk && <span class="asterisk_out">*</span>}{' '}
          {isIncumbent && (
            <span class="pill pill--basic" title="Currently holds this seat">
              Incumbent
            </span>
          )}
        </th>
        <td class="candidate__cell candidate__votes">
          {uncontested == false ? intcomma(votes) : '—'}
        </td>
        <td class="candidate__cell candidate__pct">
          {uncontested == false
            ? formatPercent(votes, totalVotesInContest)
            : '—'}
          <span class="candidate__pct-symbol">%</span>
        </td>
      </tr>
    );
  }
}

CandidateRow.defaultProps = {
  contestIsCalled: false,
  isViewable: true,
};

CandidateRow.Header = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Votes
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Pct.
        <span class="candidate__pct-symbol">%</span>
      </th>
    </tr>
  </thead>
);

CandidateRow.countyHeader = (
  <thead>
    <tr>
      <th class="contest__candidate-header" colSpan={2}>
        Candidates
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Votes
      </th>
      <th class="contest__candidate-header contest__candidate-header--numeric">
        Pct.
        <span class="candidate__pct-symbol">%</span>
      </th>
    </tr>
  </thead>
);

CandidateRow.columnCount = 4;

export default CandidateRow;
